export const ToastSeverity = {
  Success: "success",
  Info: "info",
  Warn: "warn",
  Error: "error",
};

export const ToastLife = {
  Success: 3000,
  Info: 3000,
  Warn: 4000,
  Error: 4000,
};
